import { DashboardNirvanaDataProvider } from '../dataProvider/DashboardNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';

export class DashboardDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, DashboardNirvanaDataProvider);
  }
}
